import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Datetime from "react-datetime";
import Select from "react-select";
import Modal from "react-modal";
import { getNetworkMenuId, getToken } from "../../Utils/types";

import {
  GetClientListNetwork,
  getMonthsYearsAction,
} from "../../redux/actions/GlobalAction";
import { getAllProviderListNetworkAction } from "../../redux/actions/TestPackageNetworkAction";
import {
  GetInsurerDashboardDetails,
  GetTotalAppointmentAction,
} from "../../redux/actions/InsBillAction";

import { isLoadingAction } from "../../Utils/helper";
import { SearchIcon } from "../../Utils/SvgIcons";
import { placeholderSelectColor } from "../NetworkPortal/NetworkIntelligence/UsageCoverage/helper";
import { InputOptionSelect } from "../../common/InputOptionSelect";
import { clearCurrentPage } from "../NetworkPortal/ProviderProfileDetails/helper";
import { isValidDate } from "../ServicePortal/ProfileDetail/helper";
import { API_URL_WITHOUT_USER } from "../../Utils/API";
import { initDashboardFilter } from "./helper";

import CustomPagination from "../../common/CustomPagination";
import { AdditionalApptHeader, payOutHeaderValue } from "../NetworkPortal/PayOut/AdditionalApptHeader";
import moment from "moment";
import { TotalProveiderMonth } from "../NetworkPortal/PayOut/helper";
import { InsBulkUpdate } from "./InsBulkUpdate";
import { RevertMode } from "../NetworkPortal/ProviderProfileDetails/RevertMode";
import { InsEditRemarks } from "./InsEditRemarks";

export const InsurerDashboard = () => {
  const [providerValues, setProviderValues] = useState(null);
  const [client, setClient] = useState(null);
  const [searchFilter, setSearchFilter] = useState(initDashboardFilter);
  const [header, setHeader] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllFlag, setSelectAllFlag] = useState(false);
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [isExportToExcel, setIsExporToExcel] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [inputClient, setInputClient] = useState("");
  const [providerDetail, setProviderDetail] = useState([]);
  const [month, setMonth] = useState(null);
  const [showData, setShowData] = useState(false);
  const [tableIndex, setTableIndex] = useState(null);
  const [bulkSendToQC, setBulkSendToQC] = useState({ type: "", bool: false });
  const [isRevert,setIsRevert] = useState({data:null,open:false})

  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const insBillReducer = useSelector((state) => state?.InsBillingPayout);

  const dispatch = useDispatch();

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  useEffect(() => {
    dispatch(
      GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "IBU" })
    );
    dispatch(getMonthsYearsAction());
    dispatch(getAllProviderListNetworkAction());
    dispatch(GetInsurerDashboardDetails(searchFilter));
  }, []);

  const handleDataCount = (e) => {
    setSearchFilter({
      ...searchFilter,
      page: 1,
      rows: e.target.value,
    });
  };

  useEffect(() => {
    handleSearch();
  }, [searchFilter?.rows]);

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    dispatch(GetInsurerDashboardDetails({ ...searchFilter, page: 1 }));
    setSelectAll(false);
    setProviderDetail([]);
    setSelectAllFlag(false);
  };

  const downloadFile = () => {
    // isLoadingAction(true, dispatch);
    setIsLoadingExcel(true);
    const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelInsurerDashboardDetails`;
    let data = {
      ...searchFilter,
      isExportToExcel: true,
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        const filename = "InsurerBillingDetails.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
        setSelectAllFlag(false);
        setSelectAll(false);
        setProviderDetail([]);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
        // isLoadingAction(false, dispatch);
      });
  };

  const handleClear = () => {
    setClient(null);
    setProviderValues(null);
    setProviderDetail([]);
    setInputClient("");
    setSearchFilter(initDashboardFilter);
    dispatch(GetInsurerDashboardDetails(initDashboardFilter));
    setMonth(new Date().getMonth + 1);
  };

  return (
    <div className="right-section pt-1 pt-3" style={{ padding: "10px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h4>Insurer Dashboard</h4>
          </div>
          <div className="mt-3 d-flex flex-wrap gap-3">
            <div className="payputMultiSelect">
              <Select
                placeholder="Client ID/Name"
                getOptionLabel={(option) => option.clientName}
                getOptionValue={(option) => option.clientId}
                className="basic-multi-select usagecoverage-search"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                onChange={(event, i, value) => {
                  changeHandler("clients", event);
                }}
                value={
                  searchFilter?.clients === "" ? null : searchFilter?.clients
                }
                inputValue={inputClient}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") setInputClient(value);
                  if (action.action === "menu-close") {
                    setInputClient("");
                  }
                }}
                options={globalReducer?.getClientList?.map((ele) => {
                  return {
                    clientId: ele?.clientId,
                    clientName: ele?.clientName,
                    BusinessType: ele?.businessType,
                  };
                })}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
              />
            </div>
            <div className="payoutBussinessType">
              <Datetime
                dateFormat="YYYY"
                timeFormat={false}
                className="page-content payoutYearFilter"
                isValidDate={isValidDate}
                value={searchFilter?.year}
                placeholder="Select Year"
                closeOnSelect={true}
                onChange={(e) =>
                  setSearchFilter({
                    ...searchFilter,
                    year: e?.format("YYYY"),
                  })
                }
              />
            </div>
            <div className="payoutBussinessType">
              <select
                name="BusinessType"
                className="white-form-select "
                style={{ height: "60px" }}
                value={month}
                onChange={(e) => {
                  setMonth(e.target.value);
                  setSearchFilter({
                    ...searchFilter,
                    month: e.target.value ? e.target.value : null,
                  });
                }}
              >
                <option value=""> Select Month</option>
                {globalReducer?.getMonthYear?.lstMonths?.map((ele) => {
                  return (
                    <option value={+ele?.monthId}>{ele?.monthName}</option>
                  );
                })}
              </select>
            </div>
            {/* <div className="payoutBussinessType">
              <select
                name="Select Status"
                className="white-form-select "
                style={{ height: "60px" }}
                value={searchFilter?.requestStatusId}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    requestStatusId: e.target.value,
                  });
                }}
              >
                <option value="0"> Select Status</option>
                {payoutReducer?.getpayoutStatus?.map((ele) => (
                  <option value={ele?.requestStatusId}>
                    {ele?.displayName}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="payoutBussinessType">
              <input
                style={{ height: "60px" }}
                placeholder="Case No/Policy Ref. No"
                value={searchFilter?.caseNo}
                className=" white-form-select  networkInputCaseNo"
                onChange={(e) =>
                  changeHandler("caseNo", e.target.value.trim(" "))
                }
              />
            </div>
          </div>
          <br />

          <div className="col-12 d-flex gap-3 pt-2 justify-content-between mb-2">
            <div className="mt-2 gap-5 ">
              <div className=" d-flex gap-1">
                <>
                  <select
                    className="row-selectdropdown"
                    value={searchFilter?.rows}
                    onChange={(e) => {
                      handleDataCount(e);
                    }}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <p className="results">
                    Total <span>{globalReducer?.getTotalCount}</span> results
                  </p>
                </>
              </div>
            </div>

            <div className="d-flex gap-3 pt-2  justify-content-end flex-wrap">
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={handleSearch}
              >
                <a className="sidebar-links">
                  <SearchIcon />
                  <span className="sidebar-link-text">Search</span>
                </a>
              </button>
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={() => handleClear("CBU")}
              >
                <a className="sidebar-links">
                  <span className="sidebar-link-text">Clear All</span>
                </a>
              </button>

              <button
                // disabled={providerDetail?.length < 2}
                className="btn search__btn"
                type="button"
                onClick={downloadFile}
              >
                <i className="fa-solid fa-arrow-down"></i>&nbsp;Export To Excel
              </button>
              <button
                // disabled={providerDetail?.length < 2}
                className="btn search__btn"
                type="button"
                onClick={() =>
                    setBulkSendToQC({ type: "dashboardBulkRemark", bool: true })
                  }
              >
                <i className="fa-solid fa-arrow-up"></i>&nbsp; Bulk Remark Upload
              </button>
              <button
                className="search__btn ascDescBtn p-2"
                data-bs-toggle="modal"
                id="ascDescPayableBtn"
                onClick={() => {
                  setIsOpenSetting(true);
                }}
                // data-bs-target="#additionalFilterApptHeader"
                type="button"
              >
                &nbsp;
                <i class="fa-solid fa-gear" style={{ fontSize: "20px" }}></i>
              </button>
            </div>
          </div>
          {providerDetail?.length > 0 && (
            <>
              <div className="select_all_div m-2">
                {!selectAll && (
                  <>
                    <p>{providerDetail?.length} Clients are selected</p>
                    {globalReducer?.getTotalCount > searchFilter.rows && (
                      <>
                        {selectAllFlag === true && (
                          <span
                            className="select_all_primary_cases"
                            onClick={() => setSelectAll(true)}
                          >
                            Select all {globalReducer?.getTotalCount} Clients
                          </span>
                        )}
                      </>
                    )}
                  </>
                )}
                {selectAll && (
                  <p>{globalReducer?.getTotalCount} Clients are selected</p>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              {/* <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    insBillReducer?.getInsAppointmentDetail?.length ===
                    providerDetail?.length
                  }
                  onClick={(e) => {
                    if (e.target.checked) {
                      setProviderDetail(
                        insBillReducer?.getInsAppointmentDetail
                      );
                      setSelectAllFlag(true);
                    } else {
                      setSelectAll(false);
                      setProviderDetail([]);
                      setSelectAllFlag(false);
                    }
                  }}
                  readOnly
                />
              </th> */}

              <th>Insurer Name</th>
              <th style={{ textAlign: "center" }}>Policy Ref No</th>
              <th style={{ textAlign: "center" }}>Case No</th>
              <th style={{ textAlign: "center" }}>Insurer Amount</th>
              <th style={{ textAlign: "center" }}>Gross Amount</th>
              <th style={{ textAlign: "center" }}>HV Amount</th>
              <th style={{ textAlign: "center" }}>GST</th>
              {header.map((ele) => {
                return (
                  <th
                    className={`${
                      ele === "Test Details" ||
                      ele === "Additional Test" ||
                      ele === "Tests" ||
                      ele === "Package"
                        ? "financeAdditionalTest"
                        : "addHeader"
                    }`}
                  >
                    {ele}
                  </th>
                );
              })}
              <th className="addHeader">Action</th>
            </tr>
          </thead>
          {insBillReducer?.getInsAppointmentDetail?.length > 0 && (
            <tbody>
              {insBillReducer?.getInsAppointmentDetail?.map(
                (ele, itemIndex) => {
                  return (
                    <tr key={itemIndex}>
                      {/* <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={providerDetail?.some((item) => ele === item)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setProviderDetail([...providerDetail, ele]);
                            } else {
                              setSelectAllFlag(false);
                              setSelectAll(false);
                              setProviderDetail(
                                providerDetail?.filter((item) => ele !== item)
                              );
                            }
                          }}
                          readOnly
                        />
                      </td> */}
                      <td style={{ minWidth: "200px" }}>{ele?.clientName}</td>
                      <td style={{ textAlign: "center" }}>
                        {ele?.policyRefNo}
                      </td>
                      <td style={{ textAlign: "center", minWidth: "130px" }}>
                        {ele?.caseNo}
                      </td>
                      <td style={{ textAlign: "center", minWidth: "130px" }}>
                        {ele?.insurerSum?.toLocaleString("en-IN")}
                      </td>
                      <td style={{ textAlign: "center", minWidth: "130px" }}>
                        {ele?.netAmount?.toLocaleString("en-IN")}
                      </td>
                      <td style={{ textAlign: "center", minWidth: "130px" }}>{ele?.homeVisitSum?.toLocaleString("en-IN")}</td>
                      <td style={{ textAlign: "center", minWidth: "130px" }}>{ele?.gst?.toLocaleString("en-IN")}</td>
                      {header.map((col, index) => {
                        return (
                          <td
                            key={index}
                            className={`${
                              col === "Test Details" || col === "Package"
                                ? "payOutAdditionalTest"
                                : "addHeader"
                            }`}
                          >
                            {col === "Test Details" && ele.tests !== null ? (
                              <>
                                {showData === true && tableIndex === itemIndex
                                  ? ele[payOutHeaderValue[col]]
                                  : ele[payOutHeaderValue[col]]
                                      .split(" ")
                                      ?.slice(0, 10)
                                      ?.join(" ")}
                                <a
                                  id="payOutShowMoreBtn"
                                  onClick={() => {
                                    if (col === "Test Details") {
                                      // setShowData(!showData);
                                      setTableIndex(itemIndex);
                                      setShowData(
                                        showData && tableIndex === itemIndex
                                          ? false
                                          : true
                                      );
                                    }
                                  }}
                                >
                                  {ele[payOutHeaderValue[col]].split(" ")
                                    .length < 20
                                    ? ""
                                    : showData === true &&
                                      tableIndex === itemIndex
                                    ? " view less"
                                    : "...view more"}
                                </a>
                              </>
                            )  : col === "Month" ? (
                              TotalProveiderMonth(ele?.year, ele?.month)
                            ) : (
                              ele[payOutHeaderValue[col]]
                            )}
                          </td>
                        );
                      })}
                      <td style={{ textAlign: "center",}}>
                        <button
                            
                          className="btn search__btn action_export"
                          type="button"
                          //   disabled={isLoadingExcel}
                          onClick={() => {
                            setIsRevert({data:ele,open:true})
                          }}
                        >
                          Edit Remark
                        </button>
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          )}
        </table>
        {insBillReducer?.getInsAppointmentDetail?.length === 0 && (
          <p className="noRecordFound">No Record Found</p>
        )}
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={GetTotalAppointmentAction}
              IsPayoutStatus={true}
            />
          )}
        </div>
        <Modal
            isOpen={isOpenSetting}
            style={{ maxWidth: "35%" }}
            className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AdditionalApptHeader
              setIsOpenSetting={setIsOpenSetting}
              header={header}
              setHeader={setHeader}
              searchFilter={searchFilter}
            />
        </Modal>
        <Modal
            isOpen={bulkSendToQC?.bool}
            className="modal-add-user-popup modal-upload-excel-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <InsBulkUpdate
              setBulkSendToQC={setBulkSendToQC}
              bulkSendToQC={bulkSendToQC}
            />
          </Modal>
          <Modal
            isOpen={isRevert?.open}
            className="modal-add-user-popup modal-upload-excel-popup modal-remove-billing-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <InsEditRemarks
              searchFilter={searchFilter}
              setIsRevert={setIsRevert}
              isRevert={isRevert}
            />
          </Modal>
      </div>
    </div>
  );
};
